import React from 'react';
import { AlertTriangle, CheckCircle2, Loader2, ScanSearch } from 'lucide-react';
import { Button } from '../ui/button';

/** How much of the sheet actually made it through — never let rows go missing quietly. */
export const ExtractionCoverage = ({ record, rowCount, onReread, rereading }) => {
  const expected = Number(record.expected_row_count || 0);
  const extracted = Number(record.extracted_row_count || rowCount || 0);
  const skipped = Number(record.skipped_row_count || 0);
  if (!expected && !extracted) return null;

  const short = expected > extracted;
  const line = `${expected || extracted} costed row(s) detected · ${extracted} extracted · ${skipped} skipped (no cost values)`;

  return (
    <div
      className={`mt-2 flex flex-wrap items-center gap-3 border px-3 py-2 text-xs ${short || skipped ? 'border-amber-400 bg-amber-50 text-amber-900' : 'border-emerald-200 bg-emerald-50 text-emerald-800'}`}
      data-testid="extraction-coverage"
    >
      {short || skipped
        ? <AlertTriangle className="h-3.5 w-3.5 shrink-0" />
        : <CheckCircle2 className="h-3.5 w-3.5 shrink-0" />}
      <span className="font-medium" data-testid="extraction-coverage-line">{line}</span>
      {record.extraction_passes > 1 && (
        <span className="text-[11px] opacity-70">read in {record.extraction_passes} passes</span>
      )}
      {short && onReread && (
        <Button
          size="sm" variant="outline" className="h-7 border-amber-500 bg-white text-amber-900"
          onClick={() => onReread(record)} disabled={rereading === record.id}
          data-testid="extraction-coverage-reread"
        >
          {rereading === record.id
            ? <Loader2 className="mr-2 h-3 w-3 animate-spin" />
            : <ScanSearch className="mr-2 h-3 w-3" />}
          Read again
        </Button>
      )}
    </div>
  );
};
